export default "__VITE_ASSET__CZRZG3bB__"